import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAllgemeineDaten } from "../../context/AllgemeineDatenContext";
import { useKlinischerBefund } from "../../context/KlinischerBefundContext";
import { useFussstatus } from "../../context/FussstatusContext";
import { useKriterien } from "../../context/KriterienContext";
import { useKategorisierung } from "../../context/KategorisierungContext";
import { useFussstatusGrafik } from "../../context/FussstatusGrafikContext";
import { useSchuhversorgung } from "../../context/SchuhversorgungContext";
import styles from "./Abschluss.module.css";
import { generateMoveControlPdf } from "../../utils/generateMoveControlPdf";
import schuhverordnungsbogenPdf from "../../assets/Schuhverordnungsbogen.pdf";
import { generateDdgPdf } from "../../utils/generateDdgPdf";
import { generateRezeptvorschlagPdf } from "../../utils/generateRezeptvorschlagPdf";
import { isTestUser } from "../../utils/testUser"; // TEMPORÄRER TESTZUGANG

const Abschluss = () => {
  const navigate = useNavigate();
  
  const { data: AllgemeineDaten, setData: setAllgemeineDaten, clearAllgemeineDaten } = useAllgemeineDaten();
  const { data: klinischerBefund, clearKlinischerBefund } = useKlinischerBefund();
  const { data: fussstatus, clearFussstatus } = useFussstatus();
  const { data: kriterien, clearKriterien } = useKriterien();
  const { data: kategorisierung, clearKategorisierung } = useKategorisierung();
  const { data: schuhversorgung, clearSchuhversorgung } = useSchuhversorgung();
  const { data: fussstatusGrafik, clearFussstatusGrafik } = useFussstatusGrafik();

  const [isSubmitting, setIsSubmitting] = useState(false);
  // const [isCreatingPatient, setIsCreatingPatient] = useState(false);   // reused for update too
  const [messages, setMessages] = useState([]);
  const [hasAnySuccess, setHasAnySuccess] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);

  const [isPdfGenerated, setIsPdfGenerated] = useState(false);

const addMessage = (type, text) => {
  setMessages(prev => [
    ...prev,
    { id: `${Date.now()}-${Math.random().toString(36).slice(2)}`, type, text } //Generate unique id
  ]);
};

  const clearMessages = () => setMessages([]);

    // Payload for PDF generation
  const { barcode: _barcode, ...generalDataPayload } = AllgemeineDaten || {};
  const payload = {
    patient_encode: AllgemeineDaten?.barcode || null,
    shop_patient_id: "",
    general_data: generalDataPayload,
    clinical_findings: klinischerBefund || {},
    foot_status: fussstatus || {},
    foot_status_graphic: fussstatusGrafik || {},
    criteria: kriterien || {},
    categorization: kategorisierung || {},
    shoe_provision: schuhversorgung || {}
  };


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Update Patient in Shopware (PATCH) 
  const updateShopPatient = async (token, shopPatientId) => {
    // setIsCreatingPatient(true);
    try {
      const stored = JSON.parse(localStorage.getItem("AUTH_DATA") || "{}");
      const swContextToken = stored?.token;

      const salutationId =
        AllgemeineDaten?.geschlecht === "männlich" ? "de609b657f5a473298bab08c6df6d35a" :
        AllgemeineDaten?.geschlecht === "weiblich" ? "e04001f133214426b2c7c2155f2af10a" :
        "ea5064df7ac24d1e9d6455fecfd31836";

      const patientPayload = {
        lastName: AllgemeineDaten?.name || "",
        firstName: AllgemeineDaten?.vorname || "",
        salutationId: salutationId,
        birthday: AllgemeineDaten?.geburtsdatum || "",
        country: "e6eac0efce0b40ec8342b556e06266b5", //DE
      };

      const url = `${process.env.REACT_APP_API_URL}/api/data/patients/${shopPatientId}`;

      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "sw-context-token": swContextToken || "",
        },
        body: JSON.stringify(patientPayload),
      });

      const result = await response.json();

      if (response.ok) {
        addMessage("success", "Patient wurde erfolgreich im Shop aktualisiert.");
        return true;
      } else {
        addMessage("error", "Patient konnte nicht im Shop aktualisiert werden.");
        return false;
      }
    } catch (err) {
      // console.error(err);
      addMessage("error", "Patient konnte nicht im Shop aktualisiert werden.");
      return false;
    } finally {
      // setIsCreatingPatient(false);
    }
  };

  // Create Patient in Shopware (POST)
  const createShopPatient = async (token) => {
    // setIsCreatingPatient(true);
    try {
      const stored = JSON.parse(localStorage.getItem("AUTH_DATA") || "{}");
      const swContextToken = stored?.token;

      const salutationId =
        AllgemeineDaten?.geschlecht === "männlich" ? "de609b657f5a473298bab08c6df6d35a" :
        AllgemeineDaten?.geschlecht === "weiblich" ? "e04001f133214426b2c7c2155f2af10a" :
        "ea5064df7ac24d1e9d6455fecfd31836";

      const patientPayload = {
        lastName: AllgemeineDaten?.name || "",
        firstName: AllgemeineDaten?.vorname || "",
        salutationId: salutationId,
        birthday: AllgemeineDaten?.geburtsdatum || "",
        country: "e6eac0efce0b40ec8342b556e06266b5", //DE
      };

      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/data/patients`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "sw-context-token": swContextToken || "",
        },
        body: JSON.stringify(patientPayload),
      });

      const result = await response.json();

      if (response.ok && result.success && result.patientId) {
        addMessage("success", "Patient wurde erfolgreich im Shop angelegt.");

        setAllgemeineDaten(prev => ({
          ...prev,
          barcode: result.patientId
        }));

        return result.patientId;
      } else {
        addMessage("error", "Patient konnte nicht im Shop angelegt werden.");
        return null;
      }
    } catch (err) {
      // console.error(err);
      addMessage("error", "Patient konnte nicht im Shop angelegt werden.");
      return null;
    }
  };

  // Handle Submit 
  const handleSubmit = async () => {
    if (isSubmitting) return;
    
    setIsSubmitting(true);
    setHasAnySuccess(false);
    clearMessages();

    let anySuccess = false;

    try {
      const stored = JSON.parse(localStorage.getItem("AUTH_DATA") || "{}");
      const token = stored?.jwt;
      if (!token) throw new Error("Kein Authentifizierungstoken gefunden");

      const { barcode: _b, ...generalDataPayload } = AllgemeineDaten || {};
      const payload = {
        patient_encode: AllgemeineDaten?.barcode || null,
        shop_patient_id: "",
        general_data: generalDataPayload,
        clinical_findings: klinischerBefund || {},
        foot_status: fussstatus || {},
        foot_status_graphic: fussstatusGrafik || {},
        criteria: kriterien || {},
        categorization: kategorisierung || {},
        shoe_provision: schuhversorgung || {}
      };
      // TEMPORÄRER TESTZUGANG: test user has no shop session → skip shop create/update,
      // save to this system's database only (patient keeps its locally generated ID).
      if (isTestUser()) {
        // no shop step
      }
      // Update in Shop ONLY if shopListePatient is true
      else if (AllgemeineDaten?.shopListePatient === true) {
        const shopPatientId = AllgemeineDaten?.shopPatientId;
        
        if (shopPatientId) {
          const updateSuccess = await updateShopPatient(token, shopPatientId);
          if (updateSuccess) anySuccess = true;
          payload.shop_patient_id = shopPatientId;
        }
      } 
      // Create new patient in Shop (existing logic)
      else if (AllgemeineDaten?.shopListePatient === false) {
        const newPatientId = await createShopPatient(token);
        if (newPatientId) {
          payload.shop_patient_id = newPatientId;
          payload.patient_encode = AllgemeineDaten?.notShop ? AllgemeineDaten.barcode : newPatientId;
          anySuccess = true;
        }
      }

      const storeResponse = await fetch(`${process.env.REACT_APP_API_URL}/api/data/store`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const dbSuccess = storeResponse.ok;

      if (dbSuccess) {
        addMessage("success", "Alle Daten wurden erfolgreich in der Datenbank dieses Systems gespeichert.");
        anySuccess = true;
      } else {
        addMessage("error", "Die Daten konnten nicht in der Datenbank dieses Systems gespeichert werden.");
      }

      if (anySuccess) {
        setIsCompleted(true);        // This hides the buttons
      }

    } catch (error) {
      // console.error("Error submitting:", error);
      addMessage("error", "Leider ist beim Speichern etwas schiefgelaufen");
    } finally {
      setIsSubmitting(false);
    }
  };

const handleGeneratePDF = () => {
  const currentBarcode = AllgemeineDaten?.barcode;

  if (!currentBarcode) {
    alert("Keine ausreichenden Patientendaten vorhanden – bitte Formular prüfen.");
    return;
  }

  try {
    generateMoveControlPdf(payload);
    setIsPdfGenerated(true);
  } catch (err) {
    // console.error("PDF generation failed:", err);
    alert("Fehler beim Erstellen der PDF.");
  }
};

  const handleDownloadRezeptvorschlagPdf = () => {
    try {
      generateRezeptvorschlagPdf(payload);
    } catch (err) {
      alert("Fehler beim Erstellen des Rezeptvorschlag-PDFs.");
    }
  };

  const handleDownloadDdgPdf = async () => {
    try {
      await generateDdgPdf(schuhverordnungsbogenPdf, klinischerBefund, fussstatus, kriterien);
    } catch (err) {
      alert("Fehler beim Erstellen der DDG-PDF.");
    }
  };

  const handleReset = () => {
    clearAllgemeineDaten();
    clearKlinischerBefund();
    clearFussstatus();
    clearFussstatusGrafik();
    clearKategorisierung();
    clearKriterien();
    clearSchuhversorgung();
    clearMessages();
    setIsPdfGenerated(false);
    navigate("/");
  };

  return (
    <div className={styles["abschluss-page"]}>
      <div className={styles["success-icon-wrapper"]}>
        <div className={styles["success-circle"]}>
          <span className={styles["checkmark"]}>✓</span>
        </div>
      </div>
      <h1>Befundbogen abgeschlossen</h1>

      <div className={styles["messages-container"]}>
        {messages.map((msg) => (
          <div key={msg.id} className={`${styles["submit-message"]} ${styles[msg.type]}`}>
            <p>{msg.text}</p>
          </div>
        ))}
      </div>

      <div className={styles["centered-content"]}>
      <div className={styles["info-block"]}>
        <p className={styles["abschluss-text"]}>
          Der Befundbogen wurde erfolgreich ausgefüllt.
        </p>
        <p className={styles["abschluss-text-small"]}>
          Um das Formular abzuschicken, auf <b>abschicken</b> klicken.
        </p>
        <p className={styles["abschluss-text-small"]}>
          <b>Zur Startseite</b> löscht alle eingegebenen Daten und springt auf die erste Seite.
        </p>
        <p className={styles["abschluss-text-small"]}>
          <b>Rezeptvorschlag PDF generieren</b><br />
          Erstellt ein PDF mit den Patientendaten und dem ermittelten Rezeptvorschlag aus der Kategorisierung nach Risikogruppen.
        </p>
        <p className={styles["abschluss-text-small"]}>
          <b>DDG PDF generieren</b><br />
          Um den Schuhverordnungsbogen als PDF herunterzuladen, auf <b>DDG PDF generieren</b> klicken.<br />
          Die PDF-Datei wird heruntergeladen.
        </p>
        <p className={styles["abschluss-text-small"]}>
          <b>PDF generieren</b><br />
          Um ein PDF zu generieren, auf <b>PDF generieren</b> klicken.<br />
          Die PDF-Datei wird heruntergeladen.<br /><br />
          <b>Wenn das PDF benötigt wird, muss es vor dem Klick auf abschicken generiert werden, da die Daten danach gelöscht werden.</b><br />
          <span className={styles["pdf-hinweis-blau"]}>
            <b>Es wird standardmäßig im Download-Ordner Ihres Gerätes gespeichert
            (sofern Sie den Standard-Speicherort nicht geändert haben) oder suchen Sie in dem
            Speicherort, an dem Ihr Gerät heruntergeladene Dateien ablegt.</b>
          </span>
        </p>
      </div>

      <div className={styles.actions}>
        {!isCompleted && (
          <>
            <button
              className={styles["btn-primary"]}
              onClick={() => navigate("/schuhversorgung")}
              disabled={isSubmitting}
            >
              Zurück
            </button>
            <button
              className={styles["btn-primary"]}
              onClick={handleGeneratePDF}
              disabled={isSubmitting}
            >
              PDF generieren
            </button>
            <button
              className={styles["btn-primary"]}
              onClick={handleDownloadDdgPdf}
              disabled={isSubmitting}
            >
              DDG PDF generieren
            </button>
            <button
              className={styles["btn-primary"]}
              onClick={handleDownloadRezeptvorschlagPdf}
              disabled={isSubmitting}
            >
              Rezeptvorschlag PDF
            </button>
            <button
              className={styles["btn-primary"]}
              onClick={handleSubmit}
              disabled={isSubmitting || !isPdfGenerated}                  
            >
              {isSubmitting ? "Anfrage wird verarbeitet..." : "Abschicken"}
            </button>
          </>
        )}

        <button
          className={styles["btn-primary"]}
          onClick={handleReset}
          disabled={isSubmitting}
        >
          Zur Startseite
        </button>
      </div>
      </div>
    </div>
  );
};

export default Abschluss;